module.exports = __webpack_public_path__ + "img/face_auth_advantage_2.4981ae9a.png";